import Image from 'next/image';
import { AvatarContainer, DesktopImage, MobileImage } from './styles';
import { AvatarProps } from './types';

/**
 * @deprecated use CustomAvatar instead
 */
export function Avatar({
  userName,
  userImage,
  className,
  size,
  backgroundColor,
  fontSize,
}: AvatarProps): JSX.Element {
  if (userImage) {
    return (
      <AvatarContainer className={className} size={size} fontSize={fontSize}>
        <DesktopImage>
          {userImage && (
            <Image
              src={userImage}
              height={size.desktop}
              width={size.desktop}
              layout="intrinsic"
              objectFit="cover"
            />
          )}
        </DesktopImage>
        <MobileImage>
          {userImage && (
            <Image
              src={userImage}
              height={size.mobile}
              width={size.mobile}
              layout="intrinsic"
              objectFit="cover"
            />
          )}
        </MobileImage>
      </AvatarContainer>
    );
  }

  if (userName) {
    const imageSrc = `https://ui-avatars.com/api/?name=${userName
      .charAt(0)
      .toUpperCase()}&background=${backgroundColor}&color=fff&size=${
      size.desktop
    }&rounded=true`;
    return (
      <AvatarContainer className={className} size={size} fontSize={fontSize}>
        <DesktopImage>
          <Image
            src={imageSrc}
            height={size.desktop}
            width={size.desktop}
            layout="intrinsic"
            objectFit="cover"
          />
        </DesktopImage>
        <MobileImage>
          <Image
            src={imageSrc}
            height={size.mobile}
            width={size.mobile}
            layout="intrinsic"
            objectFit="cover"
          />
        </MobileImage>
      </AvatarContainer>
    );
  }

  return (
    <AvatarContainer className={className} size={size} fontSize={fontSize}>
      <DesktopImage>
        <Image
          src="/icons/user.svg"
          height={size.desktop}
          width={size.desktop}
          layout="intrinsic"
          objectFit="cover"
        />
      </DesktopImage>
      <MobileImage>
        <Image
          src="/icons/user.svg"
          height={size.mobile}
          width={size.mobile}
          layout="intrinsic"
          objectFit="cover"
        />
      </MobileImage>
    </AvatarContainer>
  );
}

Avatar.defaultProps = {
  userImage: '',
  className: '',
  size: {
    desktop: 75,
    mobile: 40,
  },
  fontSize: 35,
  backgroundColor: '5fa3a9',
};
